export default __webpack_public_path__ + "static/media/line2.66d7f6f8.svg";